<!-- Load login custom page styles -->
<style lang="scss">
@import "@/assets/sass/pages/login/login-1.scss";
</style>

<script>
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import { initFbsdk } from "@/core/config/facebook.js";
import { API_URL, MEDIA_URL } from "@/core/api";
// FormValidation plugins
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import SubmitButton from "@/assets/plugins/formvalidation/dist/es6/plugins/SubmitButton";
import Navbar from "@/view/front/components/navbar";
import Switcher from "@/view/front/components/switcher";
import Footer from "@/view/front/components/footer";

import KTUtil from "@/assets/js/components/util";
import { mapGetters, mapState } from "vuex";
import { LOGIN, LOGOUT, REGISTER } from "@/core/services/store/auth.module";
import Swal from "sweetalert2";
import axios from "axios";

export default {
  name: "login-1",
  data() {
    return {
      recruiterSignUp: false,
      agencySignUp: false,
      state: "signin",
      form: {
        email: "",
        password: "",
      },
      cities: [],
      apiUrl: API_URL,
      search_text: "",
      selected_cities: [],
      novalidate: "",
      showPassword: true,
    };
  },
  computed: {
    ...mapState({
      errors: (state) => state.auth.errors,
    }),

    ...mapGetters(["currentUser"]),

    backgroundImage() {
      return (
        process.env.BASE_URL + "media/svg/illustrations/login-visual-1.svg"
      );
    },
  },

  mounted() {
    var link = !!document.querySelector("link[rel='canonical']")
      ? document.querySelector("link[rel='canonical']")
      : document.createElement("link");
    link.setAttribute("rel", "canonical");
    link.setAttribute(
      "href",
      location.protocol + "//" + location.host + location.pathname
    );
    document.head.appendChild(link);
    if (window.location.href.indexOf("register") !== -1) {
      this.showForm("signup");
    }

    const signup_form = KTUtil.getById("kt_login_signup_form");

    this.fv1 = formValidation(signup_form, {
      fields: {
        fullname: {
          validators: {
            notEmpty: {
              message: "Full name is required",
            },
          },
        },
        email: {
          validators: {
            notEmpty: {
              message: "Email is required",
            },
            emailAddress: {
              message: "The value is not a valid email address",
            },
          },
        },
        password: {
          validators: {
            notEmpty: {
              message: "Password is required",
            },
          },
        },
        cpassword: {
          validators: {
            notEmpty: {
              message: "Confirm password is required",
            },
            identical: {
              compare: function() {
                return signup_form.querySelector('[name="password"]').value;
              },
              message: "Passwords do not match",
            },
          },
        },

        agree: {
          validators: {
            notEmpty: {
              message: "Please accept terms and conditions",
            },
          },
        },
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap(),
      },
    });
  },
  components: {
    Navbar,
    Switcher,
    Footer,
  },
  methods: {
    showForm(form) {
      console.log("test");
      this.state = form;
      var form_name = "kt_login_" + form + "_form";
      KTUtil.animateClass(
        KTUtil.getById(form_name)
        // "animate__animated animate__backInUp"
      );
    },
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    toggleMenu() {
      this.isCondensed = !this.isCondensed;
      if (this.isCondensed) {
        document.getElementById("navigation").style.display = "block";
      } else document.getElementById("navigation").style.display = "none";
    },
    onSubmitRegister() {
      // this.fv1.on("core.form.valid", () => {
      this.fv1.validate();
      this.fv1.validate().then((res) => {
        if (res == "Valid") {
          const firstName = this.$refs.firstName.value;
          const lastName = this.$refs.lastName.value;
          const email = this.$refs.remail.value;
          const password = this.$refs.rpassword.value;
          // const compnay_name = this.$refs.compnay_name.value;
          const compnay_name =
            this.recruiterSignUp == true || this.agencySignUp == true
              ? this.$refs.compnay_name.value
              : null;

          // clear existing errors
          this.$store.dispatch(LOGOUT);

          // set spinner to submit button
          const submitButton = this.$refs["kt_login_signup_submit"];
          submitButton.classList.add(
            "spinner",
            "spinner-light",
            "spinner-right"
          );

          // dummy delay
          setTimeout(() => {
            // send register request
            console.log("Register page log");
            this.$store.dispatch(REGISTER, {
              email: email,
              password: password,
              name: firstName + " " + lastName,
              compnay_name: compnay_name,
              role_id:
                this.recruiterSignUp == true
                  ? "2"
                  : this.agencySignUp == true
                  ? "6"
                  : "1",
            });

            submitButton.classList.remove(
              "spinner",
              "spinner-light",
              "spinner-right"
            );
          }, 2000);
        } else {
          Swal.fire({
            title: "",
            text: "Please, provide correct data!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        }
      });

      // });

      // this.fv1.on("core.form.invalid", () => {
      //   Swal.fire({
      //     title: "",
      //     text: "Please, provide correct data!",
      //     icon: "error",
      //     confirmButtonClass: "btn btn-secondary",
      //     heightAuto: false,
      //   });
      // });
    },

    AuthProvider(provider) {
      var self = this;

      this.$auth
        .authenticate(provider)
        .then((response) => {
          self.SocialLogin(provider, response);
        })
        .catch((err) => {
          // console.log({ err: err });
        });
    },
  },
  metaInfo: function() {
    return {
      title: "Job Seeker registration - Find your Dream Job - job4u.pk",
      meta: [
        {
          name: "description",
          content:
            "Register at job4u.pk for thousands of jobs & career opportunities in Pakistan. Get yourself register now and find your dream job with job4u.pk",
        },
      ],
    };
  },
};
</script>
<template>
  <div class="mt-17">
    <Navbar />
    <div class="rigister_image_bg">
      <div class="container" style="margin: 0 auto">
        <div
          class="login login-1"
          :class="{
            'login-signin-on': this.state == 'signin',
            'login-signup-on': this.state == 'signup',
            'login-forgot-on': this.state == 'forgot',
          }"
          id="kt_login"
        >
          <div class="row align-items-center">
            <!--begin::Aside-->
            <div class="col-lg-4 auth_heading">
              Enter into the world of
              <span class="font-weight-bolder"> opportunities</span>
            </div>
            <!--begin::Aside-->
            <!--begin::Content-->
            <div class="col-lg-5 row m-0 col-md-6 bg-white p-0 Small">
              <div class="col-12 mb-5 row m-0 ch_rej_btn_h1 p-0">
                <h2 class="col-6 row m-0 job_sekker_btn1">
                  <a href=""
                    >Register as a <br />
                    job Seeker</a
                  >
                </h2>
                <h4 class="col-6 row m-0 text-center job_sekker_btn2">
                  <a href="/recruiter-registeration">
                    Register to recruit <br />
                    talent</a
                  >
                </h4>
                <!-- <p>Register as a recruiter</p> -->
              </div>
              <div class="px-10 pb-9">
                <div class="">
                  <!--begin::Signup-->
                  <div class="login-form login-signup">
                    <form
                      class="form text-center"
                      novalidate="novalidate"
                      id="kt_login_signup_form"
                      @submit.stop.prevent="onSubmitRegister()"
                    >
                      <div class="pb-2 pt-lg-0 pt-5">
                        <p>Register as a job seeker</p>
                      </div>

                      <!-- <div class="form-check form-check-inline text-muted">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="direct_recruitment"
                          selected="true"
                          id="direct_employer"
                          @change="
                            () => {
                              recruiterSignUp = true;
                              agencySignUp = false;
                              showForm('signup');
                            }
                          "
                        />
                        <label class="form-check-label" for="direct_employer">
                          Direct employer
                        </label>
                      </div>
                      <div class="form-check form-check-inline mb-5">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="direct_recruitment"
                          id="recruitment_agency"
                          @change="
                            () => {
                              agencySignUp = true;
                              recruiterSignUp = false;
                              showForm('signup');
                            }
                          "
                        />
                        <label
                          class="form-check-label text-muted"
                          for="recruitment_agency"
                        >
                          Recruitment agency
                        </label>
                      </div> -->

                      <div class="form-group auth_inputs_img position-relative">
                        <img
                          src="/images/login_contact/usernameemail.svg"
                          alt=""
                        />
                        <input
                          class="form-control fieldch"
                          type="text"
                          placeholder="First name"
                          name="firstName"
                          ref="firstName"
                          autocomplete="off"
                        />
                      </div>
                      <div class="form-group auth_inputs_img position-relative">
                        <img
                          src="/images/login_contact/usernameemail.svg"
                          alt=""
                        />
                        <input
                          class="form-control fieldch"
                          type="text"
                          placeholder="Last name"
                          name="lastName"
                          ref="lastName"
                          autocomplete="off"
                        />
                      </div>
                      <div
                        v-if="recruiterSignUp"
                        class="form-group auth_inputs_img position-relative"
                      >
                        <img src="/images/login_contact/co.svg" alt="" />
                        <input
                          class="form-control fieldch"
                          type="text"
                          placeholder="Company name"
                          name="compnay_name"
                          ref="compnay_name"
                          autocomplete="off"
                        />
                      </div>
                      <div
                        v-if="agencySignUp"
                        class="form-group auth_inputs_img position-relative"
                      >
                        <img src="/images/login_contact/co.svg" alt="" />
                        <input
                          class="form-control fieldch"
                          type="text"
                          placeholder="Company name"
                          name="compnay_name"
                          ref="compnay_name"
                          autocomplete="off"
                        />
                      </div>
                      <div class="form-group auth_inputs_img position-relative">
                        <img src="/images/login_contact/email.svg" alt="" />
                        <input
                          class="form-control fieldch"
                          type="email"
                          placeholder="Email Address"
                          name="email"
                          ref="remail"
                          autocomplete="off"
                        />
                      </div>
                      <div class="form-group auth_inputs_img position-relative">
                        <img src="/images/login_contact/password.svg" alt="" />
                        <input
                          class="form-control fieldch"
                          placeholder="Enter Password"
                          name="password"
                          ref="rpassword"
                          autocomplete="off"
                          :type="showPassword === false ? 'text' : 'password'"
                        />
                        <span
                          @click="toggleShow"
                          class="icon is-small is-right password_show_ch"
                        >
                          <i
                            :class="
                              showPassword === false
                                ? 'fas fa-eye-slash'
                                : 'fas fa-eye'
                            "
                          ></i>
                        </span>
                      </div>
                      <div class="form-group auth_inputs_img position-relative">
                        <img src="/images/login_contact/password.svg" alt="" />
                        <input
                          class="form-control fieldch"
                          placeholder="Retype Password"
                          name="cpassword"
                          ref="cpassword"
                          autocomplete="off"
                          :type="showPassword === false ? 'text' : 'password'"
                        />
                        <span
                          @click="toggleShow"
                          class="icon is-small is-right password_show_ch"
                        >
                          <i
                            :class="
                              showPassword === false
                                ? 'fas fa-eye-slash'
                                : 'fas fa-eye'
                            "
                          ></i>
                        </span>
                      </div>
                      <div class="form-group mb-0">
                        <label
                          class="checkbox mb-0"
                          style="color: #3f4254 !important"
                        >
                          <p class="ml-2">
                            <input
                              class="mr-1 align-middle"
                              type="checkbox"
                              name="agree"
                            />
                            I have read and accept the
                            <a
                              href="/terms-and-conditions"
                              class="ml-1 text-primary font-weight-bolder"
                              >terms and conditions</a
                            >
                          </p>
                        </label>
                      </div>
                      <div class="form-group d-flex flex-wrap pb-lg-0 pb-3">
                        <!-- @click="onSubmitRegister()" -->
                        <button
                          ref="kt_login_signup_submit"
                          class="btn submitBnt"
                          style="width: 150px"
                        >
                          SIGN UP
                        </button>
                      </div>
                    </form>
                  </div>

                  <div class="hr_blue"></div>
                  <div
                    class="text-muted text-center"
                    style="font-size: 13px !important"
                  >
                    Register as a Employer OR Recruitment agency?
                    <a
                      id=""
                      class="text-primary font-weight-bolder"
                      href="/recruiter-registeration"
                      >Register</a
                    >
                  </div>
                  <div
                    class="text-muted text-center"
                    style="font-size: 13px !important"
                  >
                    Already have an account?
                    <a
                      id=""
                      class="text-primary font-weight-bolder"
                      href="/login"
                      >Login</a
                    >
                  </div>
                  <!--end::Signup-->

                  <!--begin::Forgot-->
                  <div class="login-form login-forgot">
                    <!--begin::Form-->
                    <form
                      class="form"
                      novalidate="novalidate"
                      id="kt_login_forgot_form"
                      ref="kt_login_forgot_form"
                    >
                      <div class="">
                        <h1 class="auth_title">Forgotten Password</h1>
                        <p
                          class="text-muted text-center"
                          style="font-size: 12px"
                        >
                          Enter your email to reset your password
                        </p>
                      </div>
                      <div class="form-group auth_inputs_img position-relative">
                        <img src="/images/login_contact/email.svg" alt="" />
                        <input
                          class="form-control fieldch"
                          type="email"
                          placeholder="Enter Email Adserss"
                          name="email"
                          autocomplete="off"
                        />
                      </div>
                      <div class="form-group d-flex flex-wrap pb-lg-0">
                        <button
                          type="button"
                          id="kt_login_forgot_submit"
                          class="btn submitBnt"
                        >
                          Sign In
                        </button>
                      </div>
                    </form>
                  </div>
                  <!--end::Forgot-->
                </div>
                <!--begin::Content footer-->
                <div class="text-center pt-8">
                  <a
                    href="/terms-and-conditions"
                    class="font-weight-bold font-size-h6"
                    >Terms</a
                  >
                  <a
                    href="/recruiter"
                    class="ml-10 font-weight-bold font-size-h6"
                    >Plans</a
                  >
                  <a
                    href="/contact-us"
                    class="ml-10 font-weight-bold font-size-h6"
                    >Contact Us</a
                  >
                </div>
                <!--end::Content footer-->
              </div>
            </div>
            <!--end::Content-->
          </div>
        </div>
      </div>
    </div>
    <div>
      <!-- Footer Start -->
      <Footer />
      <!-- Footer End -->
      <Switcher />
      <!-- Back to top -->
      <a
        href="javascript: void(0);"
        class="btn btn-icon btn-soft-primary back-to-top"
        id="back-to-top"
        v-scroll-to="'#topnav'"
      >
        <arrow-up-icon class="icons"></arrow-up-icon>
      </a>
      <!--end footer-->
    </div>
  </div>
</template>
<style scoped>
footer span,
footer a,
footer p,
footer h4,
footer label {
  color: white !important;
}
</style>
